import { createClient } from '@supabase/supabase-js';
import { InferGetServerSidePropsType } from 'next';
import CryptoJS from 'crypto-js';
import { useEffect, useState } from 'react';
import { modals } from '@mantine/modals';
import { Button, Modal, TextInput } from '@mantine/core';
import TemplateComponent from './TemplatePage';
import { TemplateData, TierListData } from './TemplateResults';
import { supabaseAnonClient } from '../src/Utils';

import { Database } from '../types/supabase';
import { tierListGetStaticProps } from '../pages/[[...slug]]';
import { QuizComponent } from './QuizPage';

export type TableImageData = {
  path: string;
  name: string;
  id?: string;
};

export default function TierListPage({
  tierListData,
  saveData,
  encrypted,
  isQuiz,
}: InferGetServerSidePropsType<typeof tierListGetStaticProps>) {
  const [realTemplateData, setRealTemplateData] = useState<TemplateData | null>(null);
  const [realSaveData, setRealSaveData] = useState<TierListData | null>(null);
  const [inputPassword, setInputPassword] = useState('');
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);

  const checkPassword = () => {
    try {
      if (saveData) {
        const bytes = CryptoJS.AES.decrypt(saveData as string, inputPassword);
        const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        setRealSaveData(decryptedData);
      }

      const bytes = CryptoJS.AES.decrypt(tierListData as string, inputPassword);
      const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      setRealTemplateData(decryptedData);
      setOpen(false);
    } catch (err) {
      setError(true);
    }
  };

  useEffect(() => {
    if (encrypted) {
      setOpen(true);
    }
  }, []);

  return (
    <>
      <Modal
        opened={open}
        centered
        onClose={() => {
          console.log('');
        }}
        withCloseButton={false}
        title="Enter Password"
      >
        <TextInput
          label="Enter Password"
          placeholder="Password"
          data-autofocus
          error={error ? 'Incorrect Password' : null}
          onChange={(event) => setInputPassword(event.currentTarget.value)}
        />
        <Button
          fullWidth
          onClick={() => {
            checkPassword();
            modals.closeAll();
          }}
          mt="md"
        >
          Submit
        </Button>
      </Modal>
      {(!encrypted || realTemplateData) &&
        (isQuiz ? (
          <QuizComponent
            tierListData={encrypted ? realTemplateData! : (tierListData as TemplateData)}
            saveData={saveData && (encrypted ? realSaveData! : (saveData as TierListData))}
          />
        ) : (
          <TemplateComponent
            tierListData={encrypted ? realTemplateData! : (tierListData as TemplateData)}
            saveData={saveData && (encrypted ? realSaveData! : (saveData as TierListData))}
          />
        ))}
    </>
  );
}
